<template>
  <v-card class="tool-card" :class="{ recommended: tool.score >= 8 }">
    <v-img
      v-if="tool.image_url"
      :src="tool.image_url"
      height="200px"
      cover
      class="tool-card-image"
    ></v-img>
    <div v-if="tool.score >= 8" class="recommended-badge">⭐ Recommended</div>
    <v-card-title class="title multiline-text d-flex align-items-start gap-2">
      <strong>{{ tool.name }}</strong>
      <v-chip v-if="tool.score" size="small" class="score-chip">
        {{ tool.score }}/10
      </v-chip>
    </v-card-title>

    <v-card-text class="multiline-text description">
      {{ tool.description }}

      <div v-if="tool.use_case" class="details-section">
        <p class="detail-item">
          <strong>Use Case:</strong> {{ tool.use_case }}
        </p>
      </div>

      <div v-if="tool.location" class="details-section">
        <p class="detail-item">
          <strong>Location:</strong> {{ tool.location }}
        </p>
      </div>

      <div v-if="tool.comments" class="comments-section">
        <h4>💡 Notes</h4>
        <p class="multiline-text">{{ tool.comments }}</p>
      </div>
    </v-card-text>

    <div v-if="tool.url" class="tool-footer">
      <v-btn
        :href="tool.url"
        target="_blank"
        variant="text"
        size="small"
        append-icon="mdi-open-in-new"
      >
        Learn More
      </v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    tool: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.tool-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 300px;
  border: 2px solid var(--secondaryColor) !important;
  border-radius: 8px;
  transition: transform 0.2s, box-shadow 0.2s;
  margin-top: 0px !important;
}

.tool-card.recommended {
  background: linear-gradient(
    135deg,
    var(--backgroundColorLight) 0%,
    var(--backgroundColor) 100%
  ) !important;
  border: 4px solid var(--primaryColor) !important;
}

.recommended-badge {
  font-size: 0.75rem;
  font-weight: bold;
  color: var(--primaryColor);
  margin-bottom: 8px;
  padding: 20px;
  padding-bottom: 0px;
}

.tool-card :deep(.v-card-title) {
  color: var(--primaryColor) !important;
  font-weight: bold !important;
  padding: 0 0 8px 0 !important;
  display: flex !important;
  align-items: flex-start !important;
  gap: 8px !important;
  line-height: 1.2;
}

.tool-card .title {
  color: var(--darkColor);
  font-size: 0.9rem;
  padding: 20px !important;
}
.tool-card .description {
  color: var(--darkColor);
  font-size: 0.9rem;
  padding: 0px 20px !important;
}

.details-section {
  margin-bottom: 12px;
}

.detail-item {
  margin: 8px 0;
  color: var(--darkColor);
  font-size: 0.85rem;
  line-height: 1.4;
}

.comments-section {
  background-color: var(--secondaryColorLighter);
  padding: 12px;
  border-radius: 6px;
  margin: 12px 0;
}

.comments-section h4 {
  margin: 0 0 8px 0;
  color: var(--primaryColor);
  font-size: 0.9rem;
  font-weight: bold;
}

.comments-section p {
  margin: 0;
  color: var(--darkColor);
  font-size: 0.85rem;
}

.score-chip {
  background-color: var(--primaryColor) !important;
  color: white !important;
  font-weight: bold;
  flex-shrink: 0;
}

.multiline-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  overflow: visible;
  text-overflow: unset;
}

.tool-footer {
  display: flex;
  justify-content: flex-end;
  padding: 12px;
  border-top: 1px solid var(--secondaryColor);
}
</style>
